import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

// Async thunk for fetching emojis
export const fetchEmojis = createAsyncThunk(
  'textEmojis/fetchEmojis',
  async ({ text, filters }, { rejectWithValue }) => {
    try {
      // Log the API request for debugging
      console.log('Sending emojis request with:', { text: text.substring(0, 30) + '...', filters });
      
      const response = await apiCall('/get-emojis', 'POST', { text, filters });
      // Check if the response contains an error
      if (response.error) {
        return rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      console.error('Emojis API error details:', error);
      return rejectWithValue('Error fetching emojis');
    }
  }
);

const emojisSlice = createSlice({
  name: 'emojisAnalyzer',
  initialState: {
    emojis: '', // Stores the emojis returned by the API
    loading: false, // Loading state for async operations
    error: null, // Error messages from failed requests
  },
  reducers: {
    updateEmojis: (state, action) => {
      state.emojis = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmojis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmojis.fulfilled, (state, action) => {
        state.loading = false;
        state.emojis = action.payload.emojis;
      })
      .addCase(fetchEmojis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch emojis';
      });
  },
});

// Export actions and reducer
export const { updateEmojis } = emojisSlice.actions;
export default emojisSlice.reducer;
